<template>
        <div class="wrapper">
        <v-layout>
            <v-main style="">
                <v-container>
                    <v-row justify="left">
                        <v-col cols="12" md="12" lg="8" xl="8">
                                        <h4 class="
                                        text-h6
                                        text-md-h6
                                        text-lg-h5
                                        text-xl-h5
                                        text-truncate">
                                            Disclaimer
                                        </h4>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="12" lg="8" xl="8">

                            <b>1. General Information</b><br />
                            The information provided on this web application is for research informational
                            purposes only and not intended for clinical use.<br/>
                            While we strive to ensure that all content is accurate and up-to-date, we make no representations
                            or warranties of any kind, express or implied, about the completeness, accuracy, reliability,
                            suitability, or availability with respect to the website or the information, services, or
                            related graphics contained on the website for any purpose.
                            Any reliance you place on such information is strictly at your own risk.<br /><br />

                            <b>2. Limitation of Liability</b><br />
                            We make every effort to keep the information on our website up to date. However, we do not
                            accept liability for the content provided. We are
                             not obligated to monitor third-party information provided or stored on our website or to
                             investigate circumstances indicating illegal activity. Obligations to remove or block the
                             use of information under general law remain unaffected.<br />

                            We are not liable for any loss or damage, including but not limited to direct, indirect,
                            incidental, consequential, or punitive damages, arising from the use of this web application
                            or the inability to use it, even if advised of the possibility of such damages.
                            This includes, without limitation, damages resulting from:<br/>

                                Errors, omissions, or inaccuracies in the content.<br />
                                Downtime or interruptions of service.<br />
                                Loss of data due to uploads, misuse, or errors.<br />
                                Unauthorized access to or alteration of your data.
                            <br/><br/>

                            <b>3. Use and Restrictions</b><br />
                            By using the upload feature in this web application, you confirm that you have the legal
                            right to use and upload the data.
                            We are not responsible for the content you upload or any
                            legal consequences that arise from the upload or use of such data. Users are solely responsible
                            for ensuring that their data complies with applicable laws and does not infringe on the rights
                            of third parties.
                            <br /><br/>

                            <b>4. External Links</b><br />
                            Onkopus may contain links to external websites that are not controlled or
                            operated by us. We have no control over the content or practices of these external websites
                            and accept no responsibility or liability for them. The inclusion of any links does not
                            necessarily imply a recommendation or endorse the views expressed within them.
                            <br/><br/>

                            <b>5. No Guarantee of Availability</b><br />
                            We do not guarantee that the web application will always be available, uninterrupted, or
                            free of errors. Maintenance, updates, or technical issues may temporarily affect availability,
                            and we reserve the right to modify, suspend, or discontinue the web application at any
                            time without notice.
                            <br /><br/>

                            <b>6. Intellectual Property</b><br />
                            All intellectual property rights related to this web application, including text, images,
                            logos, and software, remain the property of their respective owners. Unauthorized use,
                            reproduction, or distribution of any content from this application is prohibited and may
                            result in legal action.
                            The application, including all associated intellectual property rights, is owned by the
                            University Medical Center Göttingen (UMG) and is protected by applicable copyright, trademark, and other
                            intellectual property laws.
                            <br /><br />

                            <b>7. Changes to the Disclaimer</b><br />
                            We reserve the right to update this disclaimer at any time. Users are encouraged to review the disclaimer periodically to stay informed of any changes.

                            <br /><br/>

                        </v-col>
                    </v-row>
                </v-container>
            </v-main>
        </v-layout>
    </div>
</template>
<style>
</style>
